<template>
  <PageLoading v-if="loading" />
</template>

<script>
import { api } from "@/services";

export default {
  name: "LoginRedirect",
  data() {
    return {
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    const token = this.$route.query.token;

    window.localStorage.CHIAuPairAuthToken = `Bearer ${token}`;

    try {
      await api.validate();
      await this.$store.dispatch("getUser");
      this.loading = false;
      this.$router.push({ name: "Home" });
    } catch (error) {
      this.$router.push({ name: "Login" });
      window.localStorage.removeItem("CHIAuPairAuthToken");
      this.loading = false;
    }
  },
};
</script>
